







import { Component } from 'vue-property-decorator';
import VModalConfirmation from '@/components/popup/VModalConfirmation.vue';
import VLoading from '@/components/items/VLoading.vue';
import Mixin from '@/mixin';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';

@Component({
  name: 'App',
  components: { VLoading, VModalConfirmation }
})
export default class App extends Mixin {
  public async showPopup(isShow: boolean) {
    await Promise.all([
      popupModule.initPopup(popup.mobileSupport),
      popupModule.setShowPopup(isShow)
    ]);
  }

  mounted() {
    if (this.isMobile()) {
      this.showPopup(true);
    }
  }
}
